import React from 'react'
import Aboutme from './Aboutme'
import Projects from './Projects'
import Research from './Research'
import NavBar from '../Components/NavBar'
import List from '../Components/List'
import Footer from '../Components/Footer'


export default class Main extends React.Component {
    render(){
        return(
            <div className="container">
                <NavBar />
                <div className="list">
                    <List />
                </div>
                <div className="content"> 
                    <Aboutme  />
                    <Research />
                    <Projects />
                    
                </div>
                <Footer />
            </div>
        )
    }
}